import { StorageServices } from '@/services/StorageServices';
import { createStore } from 'vuex'
import * as OM from '@/Model';
import { AppNotificationClient, CompanyClient, ChatClient } from '@/services/Services';

let vuestore = {
    state: {
        user: <OM.LoggedUserVM>null,
        company: <OM.AppUserCompanyDetailVM>null,
        appCode: '',
        appVersion: <OM.SiteVersion>OM.SiteVersion.Version2,
        consts: {
            localizedValues: <{ [key: string]: string; }>{},
            enabledLanguages: <string[]>[],
        },
        showSpinner: 0,
        isMobile: false,
        appTitle: 'Welfood',
        beforeNavCbs: [],
        afterNavCbs: [],
        systemCopy: copyToClipboard,
        activeChatRoomId: <string>null,
        notificheCount: 0,
        canBuyPackages: true,
        unreadChatCount: 0,
        maintenance: false,
        getNotificheCount: () => {
            AppNotificationClient.getUnreadCount()
            .then(x => {
                store.state.notificheCount = x;
            })
        },
        getCanBuyPackages: () => {
            CompanyClient.getCanBuyPackages()
            .then(x => {
                store.state.canBuyPackages = x;
            })
            .catch(() => {
                store.state.canBuyPackages = true;
            })
        },
        getUnreadChatCount: () => {
            ChatClient.getUnreadCount(false)
            .then(x => {
                store.state.unreadChatCount = x;
            })
            .catch(() => {
                store.state.unreadChatCount = 0;
            })
        }
    }
}

let subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : '';

if(subdomain != 'app'){
    vuestore.state.appCode = subdomain;
}
// vuestore.state.appCode = "maggioli"; for testing
vuestore.state.isMobile = window.innerWidth <= 768;
window.addEventListener('resize', () => {
    store.state.isMobile = window.innerWidth <= 768;
})

let store = createStore(vuestore);
export default store


function copyToClipboard(text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    window.toastr.success("Copiato!");
}
